import { FC } from 'react';

const BookListPage: FC = () => {
    return (
        <>
            <hr />
            <h1>BookListPage</h1>
            <hr />
        </>
    );
};

export default BookListPage;
